import { Box, Typography } from "@mui/material";
import liff from "@line/liff";
import { Header, MainColorButton } from "../../components";
import { bottomButton } from "../../common/styles";

/**
 * PAY決済確認中画面
 * @returns
 */
const ConfirmingPay = () => {
  // このウインドウを閉じる
  const closeWindow = () => {
    if (liff.isInClient()) {
      liff.closeWindow();
    } else {
      window.close();
      if (!window.closed) {
        // 閉じるのに失敗した場合はアラートを出す
        alert(
          "タブを閉じることができませんでした。\nお手数ですが、ご利用のブラウザからタブを閉じてください。"
        );
      }
    }
  };

  return (
    <>
      <Header title="決済確認中" />
      <Box
        height="76vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Typography sx={{ fontSize: "110%" }} align="center">
          決済結果が確認できましたら
          <br />
          LINEにてご連絡いたします。
        </Typography>
      </Box>
      <MainColorButton
        label="閉じる"
        onClick={() => closeWindow()}
        style={bottomButton}
      />
    </>
  );
};

export default ConfirmingPay;
